import type { SlideOutProps } from '@interstate/components/SlideOut';
import { SlideOut } from '@interstate/components/SlideOut';
import { Box } from '@interstate/components/Box';

export const SlideOutWithFixedFooter = (props: SlideOutProps) => {
    const { children, ...rest } = props;
    return (
        <SlideOut
            sx={{
                '.ids-slideout-close-button': {
                    cursor: 'pointer'
                },
                '.ids-SlideOut-content': {
                    height: 'calc(100% - 135px)',
                    overflowY: 'hidden',
                    paddingBottom: '10px'
                }
            }}
            {...rest}
        >
            <Box sx={{ height: '100%', overflowY: 'auto' }} mr={-3}>
                <Box pr={3} ml={0.5}>
                    {children}
                </Box>
            </Box>
        </SlideOut>
    );
};
